import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { HistoryService } from '../history.service';

@Component({
  selector: 'cc-record-history-type',
  templateUrl: './record-history-type.component.html',
  styleUrls: ['./record-history-type.component.scss']
})
export class RecordHistoryTypeComponent implements OnInit {
  @Input() historyTypes: string[];
  @Input() eventId: number;
  @Input() contactId: number;
  public eventType: FormControl;
  constructor(public historyService: HistoryService) {}

  ngOnInit() {
    this.eventType = new FormControl(this.historyTypes[0]);
  }

  chooseType(type: string) {
    this.historyService.chooseType(type === 'ALL' ? null : type, this.contactId, this.eventId);
  }
}
